import * as actionTypes from "./actionTypes";

export const getAllPollList = (allPollList, totalPollList) => {
  return {
    type: actionTypes.GET_ALL_POLL_LIST,
    timelinePollList: allPollList,
    total: totalPollList,
  };
};

export const updatePoll = (singlePoll) => {
  return {
    type: actionTypes.UPDATE_POLL,
    poll: singlePoll,
  };
};

export const createPoll = (singlePoll) => {
  return {
    type: actionTypes.CREATE_POLL,
    poll: singlePoll,
  };
};

export const deletePoll = (pollId) => {
  return {
    type: actionTypes.DELETE_POLL,
    pollId: pollId,
  };
};

export const setPollLoader = (loaderValue) => {
  return {
    type: actionTypes.SET_POLL_LOADER,
    loaderValue: loaderValue,
  };
};

export const pollPageIncreament = () => {
  return {
    type: actionTypes.POLL_PAGE_INCREAMENT,
  };
};

export const clearAllPoll = () => {
  return {
    type: actionTypes.CLEAR_ALL_POLL,
  };
};
